export default {"src":"/_next/static/media/grid.82e3cf94.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};